// extracted by mini-css-extract-plugin
module.exports = {"tempMenu":"tempMenus_tempMenu__MpFf5","text":"tempMenus_text__3sg-d"};